import EventApi from '../../../../../api/EventsApi';
import {ZoomCommand} from '../../enums/ZoomCommand';
import {PixiApplicationController} from '../PixiApplicationController';
import {GameTableEvents} from '../../pixi_scene/game_scene/game_table/GameTableEvents';

export class RoomTableMouseWheelController
{
    /**
     * Навешиваем слушатель на колёсико мыши
     * @param zoomCallback - команда применения зума к игровому полю
     */
    static start(): void {
        PixiApplicationController.app.view.addEventListener('mousewheel', (event: Event) => {
            event.preventDefault();
            let wheelEvent: WheelEvent = event as WheelEvent;
            EventApi.triggerEvent(EventApi.START_SOUND, {sound: wheelEvent.deltaY > 0 ? 'zoomIn' : 'zoomOut'});
            dispatchEvent(new MessageEvent(GameTableEvents.ZOOM, {
                data: {
                    command: wheelEvent.deltaY > 0 ? ZoomCommand.ZOOM_OUT : ZoomCommand.ZOOM_IN,
                    wheelOffset: {x: wheelEvent.offsetX, y: wheelEvent.offsetY}
                }
            }));
        });
    }
}
